module.exports = __webpack_public_path__ + "media/portrait-bw@sm-71d1f1217f4eaff3222f5937b7c22c3a.jpg";